import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

const DarkModeToggle = () => {
  const { isDarkMode, toggleTheme } = useTheme();

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleTheme();
  };

  return (
    <button
      onClick={handleClick}
      className="relative inline-flex items-center justify-center w-12 h-6 bg-gray-200 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 cursor-pointer z-10 border border-gray-300 dark:border-gray-600"
      aria-label="Toggle dark mode"
      type="button"
      style={{ pointerEvents: 'auto' }}
    >
      <span
        className={`absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-200 ${
          isDarkMode ? 'translate-x-6' : 'translate-x-0'
        }`}
      />
      <Sun
        className={`absolute left-1 top-1 w-3 h-3 text-yellow-500 transition-opacity duration-200 ${
          isDarkMode ? 'opacity-0' : 'opacity-100'
        }`}
      />
      <Moon
        className={`absolute right-1 top-1 w-3 h-3 text-gray-600 transition-opacity duration-200 ${
          isDarkMode ? 'opacity-100' : 'opacity-0'
        }`}
      />
    </button>
  );
};

export default DarkModeToggle;
